/* less/lib/less/functions/index */ function _(require, module, exports) {
    module.exports = function (environment) {
        var functions = {
            functionRegistry: require(183) /* ./function-registry */,
            functionCaller: require(182) /* ./function-caller */
        };
        // register functions
        require(177) /* ./boolean */;
        require(181) /* ./default */;
        require(179) /* ./color */;
        require(178) /* ./color-blending */;
        require(180) /* ./data-uri */(environment);
        require(185) /* ./list */;
        require(187) /* ./math */;
        require(188) /* ./number */;
        require(189) /* ./string */;
        require(190) /* ./svg */(environment);
        require(191) /* ./types */;
        return functions;
    };
}
